(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.factory('HeaderService', [
        '$http',
        '$state',
        '$location',
        '$q',
        '$log',
        '$window',
        'AccountAuthService',
        'AnalyticsService',
        'CategoriesService',
        'FiltersSortByService',
        'FiltersService',
        'IndexService',
        'ProductApiConsumerService',
        'UtilService',
        function(
            $http,
            $state,
            $location,
            $q,
            $log,
            $window,
            AccountAuthService,
            AnalyticsService,
            CategoriesService,
            FiltersSortByService,
            FiltersService,
            IndexService,
            ProductApiConsumerService,
            UtilService
        ) {
            var _pub = {};
            var _headerData = null;
            var _headerDataPromise;
            var _wagtailSettings = null;
            var _wagtailSettingsPromise;
            var _wagtailThemeSettings = null;
            var _wagtailThemeSettingsPromise;
            var _wagtailBaseURL = UtilService.getSiteSetting('cms_base_url');

            _pub.fetchHeaderAttrs = function() {
                if (!_headerDataPromise) {
                    _headerDataPromise = ProductApiConsumerService.get('api/1.0/header/').then(function success(response) {
                        _headerData = response.data;
                    }, function error(error) {
                        $log.error("Header error: " + error);
                    });
                }
                return _headerDataPromise;
            };

            /**
             * Calls functions required to set up and open the sign up modals.
             * The main logic of this function has been moved to the IndexService, this is
             * maintained for backwards compatibility.
             *
             * @NOTE: This setting must be removed after the demo which requires us to send the users to their sites
             * after clicking on the login button.
             * @param {string} nextUrl - page to redirect to after sign in.
             */
            _pub.signIn = function(nextUrl) {
                const loginExternalUrl = UtilService.getSiteSetting('login_external_url');
                if (loginExternalUrl) {
                    $window.open(loginExternalUrl, '_blank');
                } else {
                    IndexService.signIn(nextUrl);
                }
            };

            /**
             * Returns header's data
             * @returns {$q.promise}
             */
            _pub.getHeaderData = function() {
                var deferred = $q.defer();
                if (_headerData) {
                    deferred.resolve(_headerData);
                } else {
                    _pub.fetchHeaderAttrs().then(function() {
                        deferred.resolve(_headerData);
                    });
                }
                return deferred.promise;
            };

            /**
             * Fetches the index settings object from the given Wagtail instance.
             * @returns {*}
             */
            _pub.fetchWagtailIndexSettings = function() {
                if (!_wagtailSettingsPromise) {
                    _wagtailSettingsPromise = $http.get(
                        _wagtailBaseURL + 'settings/index_page/'
                    ).then(function(response){
                        _wagtailSettings = response.data;
                    }, function() {
                        _wagtailSettings = null;
                    });
                }
                return _wagtailSettingsPromise;
            };

            /**
             * Returns the settings object from Wagtail.
             * @returns {$q.promise}
             */
            _pub.getWagtailIndexSettings = function() {
                var deferred = $q.defer();
                if (_wagtailSettings) {
                    deferred.resolve(_wagtailSettings);
                } else {
                    _pub.fetchWagtailIndexSettings().then(function() {
                        deferred.resolve(_wagtailSettings);
                    });
                }
                return deferred.promise;
            };

            /**
             * Fetches the theme settings object from the given Wagtail instance.
             * @returns {*}
             */
            _pub.fetchWagtailThemeSettings = function() {
                if (!_wagtailThemeSettingsPromise) {
                    _wagtailThemeSettingsPromise = $http.get(
                        _wagtailBaseURL + 'settings/theme/'
                    ).then(function(response){
                        _wagtailThemeSettings = response.data;
                    }, function() {
                        _wagtailThemeSettings = null;
                    });
                }
                return _wagtailThemeSettingsPromise;
            };

            /**
             * Returns the settings object from Wagtail.
             * @returns {$q.promise}
             */
            _pub.getWagtailThemeSettings = function() {
                var deferred = $q.defer();
                if (_wagtailThemeSettings) {
                    deferred.resolve(_wagtailThemeSettings);
                } else {
                    _pub.fetchWagtailThemeSettings().then(function() {
                        deferred.resolve(_wagtailThemeSettings);
                    });
                }
                return deferred.promise;
            };

            /**
             * Helper function to navigate the user back
             * to the user selected category results page.
             * @private
             */
            var _navigateToResultsPage = function() {
                // route to the category results page
                var activeCategory = CategoriesService.getActiveCategory();
                var sortBy = FiltersSortByService.getActiveSortByOption();
                var filters = FiltersService.getCategoryFilters();

                $state.go('results', {
                    sortBy: sortBy,
                    category_code: activeCategory.category_code,
                    filters: filters,
                    guide: ''
                }).then(function () {
                    _pub.trackNavEngagement('mobile back', $location.path);
                });
            };

            /**
             * Function to determine where to route the user to
             * when they hit the mobile back button.
             * On a product page, the back button routes the user to the category page.
             * On a category/results page, the back button routes the user to the home page.
             */
            _pub.mobileBackButton = function() {
                if (UtilService.stateIsProduct($state.current.name)) {
                    // don't use back history if navigated directly to page (history length <=2)
                    if ($window.history.length <= 2) {
                        _navigateToResultsPage();
                    } else {
                        $window.history.back();
                    }
                } else if (UtilService.stateIsCategory($state.current.name)) {
                    _pub.trackNavEngagement('mobile back', '/');
                    $location.path('/');
                } else if ($window.history.length > 2) {
                    _pub.trackNavEngagement('mobile back', $window.history[0]);
                    $window.history.back();
                } else {
                    _pub.trackNavEngagement('mobile back', '/');
                    $location.path('/');
                }
            };

            _pub.trackNavEngagement = function (display, url, nestedLinks) {
                AnalyticsService.reportEvent('Nav Engaged', {
                    location: 'header',
                    url: url,
                    value: display,
                    nested_value: nestedLinks
                });
            };

            /**
             * logs-out the currently logged-in user
             */
            _pub.logoutUser = function () {

                AccountAuthService.fetchCurrentUserInfo().then(function () {
                    AccountAuthService.logout();
                });
            };

            /**
             * Navigates the user back to the results page from the details page and tracks it
             *
             * @param productDetailData (object) The product data
             * @param sortBy (string) The sort by option
             * @param useHistory (boolean) should we use history to go to previous page
             */
            _pub.backToResults = function(productDetailData, sortBy, useHistory=true) {
                const trackingParams = {
                    eventAction: 'ClickedButtonBack',
                    eventCategory: 'Product',
                    attributes: {
                        productCategory: productDetailData.category.name,
                        productBrand: productDetailData.brand,
                        productId: productDetailData.id,
                        outboundLink: '',
                    }
                };

                AnalyticsService.reportEvent(
                    "Back Button Clicked",
                    trackingParams,
                    productDetailData
                );

                // don't use back history if navigated directly to page (history length <=2)
                if ($window.history.length <= 2 || useHistory === false) {
                    $state.go('results', {
                        sortBy: sortBy,
                        category_code: productDetailData.category.category_code,
                    });
                } else {
                    const currentUrl = $location.absUrl();

                    // If there is a section id in the url, then we have to navigate back twice since it was redirected
                    // from ?section=online-offers-table to /#online-offers-table
                    if(currentUrl.indexOf('#') !== -1) {
                        $window.history.back();
                        $window.history.back();
                    }
                    $window.history.back();

                }
            };

            return _pub;
        }
    ]);

})(angular);
